import { render } from "./GoalToast.vue?vue&type=template&id=33d25155&scoped=true"
import script from "./GoalToast.vue?vue&type=script&lang=js"
export * from "./GoalToast.vue?vue&type=script&lang=js"

import "./GoalToast.vue?vue&type=style&index=0&id=33d25155&scoped=true&lang=css"

import exportComponent from "/Users/cp/Code/betslip/BetslipPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d25155"]])

export default __exports__